import {
  ref, watch, nextTick,
} from '@vue/composition-api'
import axios from 'axios'
import { debounce } from 'lodash'
import { successNotification, errorNotification } from '@/utils/toast-notifications'
import axiosIns from '@/libs/axios'

export default function usePopupNotification(root) {
  const imagePreviewURL = ref('')
  const userData = JSON.parse(localStorage.getItem('userData'))
  const userCountry = userData?.country

  const createNotificationRef = ref(null)
  const DESCRIPTION_VALIDATIONS = 'required|max:240'
  const descriptionRules = ref('')
  const groups = ref([])
  const selectedGroup = ref({})
  const displayInApp = ref(false)
  const topicNotification = ref(true)
  const individualNotification = ref(false)
  const groupsNotification = ref(false)
  const notificationImage = ref(null)
  const topicOptions = [
    {
      key: 'ly_drivers',
      label: 'Libya Drivers Only',
    },
    {
      key: 'ly_users',
      label: 'Libya Riders Only',
    },
  ]
  if (userCountry !== 'LY') {
    topicOptions.unshift({
      key: 'drivers',
      label: 'Drivers Only',
    },
    {
      key: 'users',
      label: 'Riders Only',
    })
  }
  const referenceTypes = ['general', 'promo', 'URL']
  const topic = ref([])
  const userTypes = ['user', 'driver']
  const userType = ref('user')
  const notification = ref({
    title: '',
    description: '',
    expiryDate: undefined,
    userId: undefined,
    phoneNumber: undefined,
    reference_type: 'general',
    reference_value: undefined,
    url: undefined,
    cta_label_english: undefined,
    cta_label_arabic: undefined,
  })
  const isTimePresent = ref(true)
  const currentExpiryDate = ref(undefined)
  const currentExpiryTime = ref(undefined)
  const showErrorMessage = ref(false)
  const showErrorMessage2 = ref(false)

  const publishNotification = async () => {
    try {
      let image
      if (notificationImage.value) {
        const preSignedRes = await axiosIns.get('/signed-urls', {
          params: {
            nestedFolderName: 'notifications',
            fileName: notificationImage.value.name,
            isPublic: true,
          },
        })
        const { url } = preSignedRes.data.data
        await axios.put(url, notificationImage.value, {
          headers: {
            'Content-Type': notificationImage.value.type,
          },
        })
        const imageUrl = new URL(url)
        image = imageUrl.origin + imageUrl.pathname
      }
      if (individualNotification.value) {
        await root.$store.dispatch('notifications/pushIndividualNotification', {
          save_to_db: displayInApp.value,
          ttl: displayInApp.value ? `${new Date(`${notification.value.expiryDate}`).getTime()}` : undefined,
          title: notification.value.title,
          description: notification.value.description,
          id: notification.value.userId,
          phone_no: notification.value.phoneNumber ? notification.value.phoneNumber : undefined,
          type: userType.value,
          log_id: root.$route.query.id ? root.$route.query.id : undefined,
          image,
          url: notification.value.url || undefined,
          reference_type: displayInApp.value ? notification.value.reference_type : 'general',
          reference_value: displayInApp.value && notification.value.reference_type !== 'general' ? notification.value.reference_value : '',
          cta_label_english: displayInApp.value && notification.value.reference_type === 'URL' ? notification.value.cta_label_english : undefined,
          cta_label_arabic: displayInApp.value && notification.value.reference_type === 'URL' ? notification.value.cta_label_arabic : undefined,
        })
      } else if (topicNotification.value) {
        await root.$store.dispatch('notifications/pushNotificationTopic', {
          save_to_db: displayInApp.value,
          ttl: displayInApp.value ? `${new Date(`${notification.value.expiryDate}`).getTime()}` : undefined,
          topic: topic.value,
          title: notification.value.title,
          description: notification.value.description,
          log_id: root.$route.query.id ? root.$route.query.id : undefined,
          reference_type: displayInApp.value ? notification.value.reference_type : 'general',
          reference_value: displayInApp.value && notification.value.reference_type !== 'general' ? notification.value.reference_value : '',
          image,
          cta_label_english: displayInApp.value && notification.value.reference_type === 'URL' ? notification.value.cta_label_english : undefined,
          cta_label_arabic: displayInApp.value && notification.value.reference_type === 'URL' ? notification.value.cta_label_arabic : undefined,
        })
      } else {
        await root.$store.dispatch('groups/sendNotificationToGroup', {
          groupID: selectedGroup.value.id,
          data: {
            title: notification.value.title,
            description: notification.value.description,
            type: selectedGroup.value.target === 'drivers' ? 'driver' : 'user',
            topic: selectedGroup.value.name,
            log_id: root.$route.query.id ? root.$route.query.id : undefined,
            save_to_db: displayInApp.value,
            ttl: displayInApp.value ? `${new Date(`${notification.value.expiryDate}`).getTime()}` : undefined,
            reference_type: displayInApp.value ? notification.value.reference_type : 'general',
            reference_value: displayInApp.value && notification.value.reference_type !== 'general' ? notification.value.reference_value : '',
            image,
            cta_label_english: displayInApp.value && notification.value.reference_type === 'URL' ? notification.value.cta_label_english : undefined,
            cta_label_arabic: displayInApp.value && notification.value.reference_type === 'URL' ? notification.value.cta_label_arabic : undefined,
          },
        })
      }
      await new Promise(resolve => {
        setTimeout(() => {
          root.$bvModal.hide('notification-popup')
          successNotification('Notification published successfully')
          root.$router.push('/notifications')
          resolve()
        }, 2000)
      })
    } catch (error) {
      console.log(error)
    }
  }
  const selectNotificationImage = e => {
    if (e) {
      const img = document.createElement('img')
      const objectURL = URL.createObjectURL(e)
      img.onload = function handleLoad() {
        if (img.width !== 1038 && img.height !== 1038) {
          notificationImage.value = null
          errorNotification('Ensure your image dimensions are set to 1038x1038 pixels.')
        }

        URL.revokeObjectURL(objectURL)
      }

      img.src = objectURL

      document.body.appendChild(img)
      img.style.display = 'none'
    }
  }
  const onTopicNotification = () => {
    if (!topicNotification.value) {
      groupsNotification.value = true
      individualNotification.value = false
    } else {
      groupsNotification.value = false
      individualNotification.value = false
    }
    topic.value = []
  }
  const onIndividualNotification = () => {
    if (!individualNotification.value) {
      groupsNotification.value = true
      topicNotification.value = false
    } else {
      groupsNotification.value = false
      topicNotification.value = false
    }
    topic.value = []
  }
  const onGroupsNotification = () => {
    if (!groupsNotification.value) {
      topicNotification.value = true
    } else {
      topicNotification.value = false
      individualNotification.value = false
    }
    topic.value = []
  }
  const open = () => {
    descriptionRules.value = DESCRIPTION_VALIDATIONS
    nextTick(async () => {
      if (displayInApp.value) {
        if (!isTimePresent.value) return
      }
      const valid = await createNotificationRef.value.validate()
      if (valid) {
        if (groupsNotification.value) {
          root.$bvModal.show('notification-popup')
        } else if (topicNotification.value) {
          if (topic.value.length !== 0) {
            root.$bvModal.show('notification-popup')
          } else {
            showErrorMessage.value = true
          }
        } else if (notification.value.userId) {
          root.$bvModal.show('notification-popup')
        } else {
          showErrorMessage2.value = true
        }
      }
    })
  }
  const loadingDraftBtn = ref(false)
  const saveAsDraft = () => {
    descriptionRules.value = ''
    nextTick(async () => {
      if (displayInApp.value) {
        if (!isTimePresent.value) return
      }
      const isValid = await createNotificationRef.value.validate()
      if (isValid) {
        if (topicNotification.value) {
          if (topicNotification.value.length === 0) {
            showErrorMessage.value = true
            return
          }
        } else if (!notification.value.phoneNumber) {
          showErrorMessage2.value = true
          return
        }
      }
      loadingDraftBtn.value = true
      try {
        if (isValid) {
          if (root.$route.query.id) {
            await root.$store.dispatch('notifications/updateDraft', {
              log_id: root.$route.query.id,
              title: notification.value.title,
              description: notification.value.description,
              save_to_db: displayInApp.value,
              individual: !!individualNotification.value,
              id: individualNotification.value ? notification.value.userId : undefined,
              phone_no: individualNotification.value ? notification.value.phoneNumber : undefined,
              topic: individualNotification.value ? userType.value : topic.value,
              ttl: displayInApp.value ? `${new Date(`${notification.value.expiryDate}`).getTime()}` : undefined,
            })
          } else {
            await root.$store.dispatch('notifications/createDraft', {
              title: notification.value.title,
              description: notification.value.description,
              save_to_db: displayInApp.value,
              individual: !!individualNotification.value,
              id: individualNotification.value ? notification.value.userId : undefined,
              phone_no: individualNotification.value ? notification.value.phoneNumber : undefined,
              topic: individualNotification.value ? userType.value : topic.value,
              ttl: displayInApp.value ? `${new Date(`${notification.value.expiryDate}`).getTime()}` : undefined,
            })
          }
          await new Promise(resolve => {
            setTimeout(() => {
              successNotification('Saved as draft successfully')
              root.$router.push('/notifications')
              resolve()
            }, 2000)
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        loadingDraftBtn.value = false
      }
    })
  }
  watch(topic, () => {
    if (topic.value.length === 0) {
      showErrorMessage.value = true
    } else {
      showErrorMessage.value = false
    }
  }, { deep: true })
  watch(userType, () => {
    showErrorMessage2.value = false
    notification.value.userId = null
    notification.value.phoneNumber = null
  })
  watch(displayInApp, () => {
    if (!displayInApp.value) {
      currentExpiryDate.value = undefined
      currentExpiryTime.value = undefined
      isTimePresent.value = true
    }
  })
  watch([currentExpiryDate, currentExpiryTime], () => {
    if (currentExpiryDate.value && currentExpiryTime.value) {
      const year = currentExpiryDate.value.getFullYear()
      const month = currentExpiryDate.value.getMonth() + 1
      const day = currentExpiryDate.value.getDate()
      const temp = new Date(`${year}-${month}-${day} ${currentExpiryTime.value}`)
      if (temp.getTime() < new Date().getTime()) {
        isTimePresent.value = false
      } else {
        isTimePresent.value = true
      }
      notification.value.expiryDate = `${currentExpiryDate.value.getFullYear()}-${currentExpiryDate.value.getMonth() + 1}-${currentExpiryDate.value.getDate()} ${currentExpiryTime.value}`
    }
  })
  const { id } = root.$route.query
  const testNotificationHandler = async () => {
    try {
      await root.$store.dispatch('notifications/pushNotificationTopic', {
        save_to_db: displayInApp.value,
        ttl: displayInApp.value ? `${new Date(`${notification.value.expiryDate}`).getTime()}` : undefined,
        topic: ['test'],
        title: notification.value.title,
        description: notification.value.description,
      })
      successNotification('Tested successfully')
    } catch (error) {
      console.log(error)
    }
  }
  const readmode = ref(false)
  const fetching = ref(false)
  const fetchNotification = async () => {
    fetching.value = true
    const res = await root.$store.dispatch('notifications/fetchNotification', id)
    const { data } = res.data
    imagePreviewURL.value = data.image
    if (data.status === 'published') {
      readmode.value = true
    }
    notification.value.title = data.title
    notification.value.description = data?.description
    displayInApp.value = data.options.save_to_db
    if (displayInApp.value) {
      if (data.options.ttl) {
        const result = new Date(String(data.options.ttl).length === 13 ? data.options.ttl : data.options.ttl * 1000)
        currentExpiryDate.value = result
        currentExpiryTime.value = `${result.getHours()}:${result.getMinutes()}:00`
      }
    }
    if (data.options.individual) {
      individualNotification.value = data.options.individual
      topicNotification.value = false
      userType.value = data.options.topic
      notification.value.phoneNumber = data.options.phone_no
    } else {
      individualNotification.value = false
      topic.value = typeof data.options.topic === 'string' ? [data.options.topic] : [...data.options.topic]
    }
    fetching.value = false
  }

  debounce(async (search, loading) => {
    if (!search) return
    loading(true)

    const result = await axiosIns.get('/groups', {
      params: {
        name: search,
      },
    })
    const { data } = result.data.data
    groups.value = data
    selectedGroup.value = { ...groups.value[0] }
    loading(false)
  }, 1000)

  const fetchGroups = debounce(async (search, loading) => {
    if (!search) return
    loading(true)

    const result = await axiosIns.get('/groups', {
      params: {
        name: search,
      },
    })
    const { data } = result.data.data
    groups.value = data
    selectedGroup.value = { ...groups.value[0] }
    loading(false)
  }, 1000)
  if (id) {
    fetchNotification()
  }

  const previewImageInNewTab = () => {
    window.open(imagePreviewURL.value)
  }

  return {
    publishNotification,
    createNotificationRef,
    displayInApp,
    readmode,
    topicNotification,
    notificationImage,
    individualNotification,
    topicOptions,
    topic,
    groups,
    selectedGroup,
    userType,
    groupsNotification,
    userTypes,
    notification,
    onTopicNotification,
    onIndividualNotification,
    open,
    saveAsDraft,
    showErrorMessage,
    showErrorMessage2,
    loadingDraftBtn,
    testNotificationHandler,
    currentExpiryDate,
    fetching,
    imagePreviewURL,
    previewImageInNewTab,
    isTimePresent,
    currentExpiryTime,
    referenceTypes,
    descriptionRules,
    onGroupsNotification,
    fetchGroups,
    selectNotificationImage,
  }
}
